import { Fragment } from 'react'
import styled from '@emotion/styled'
import { IoIosArrowRoundForward as ArrowIcon } from 'react-icons/io'
import {
  useModal,
  useConsumerCart,
  useCheckout,
  useSessionStorage
} from 'shop/hooks'
import { Button as GenericButton } from 'shop/components/Controls'
import { OrderItem } from 'shop/types/cart'
import { useNavigate } from 'react-router-dom'
import { getCurrentProductErrors } from 'shop/utils/cart'

const CheckoutButton = () => {
  const navigate = useNavigate()
  const { openModal, closeModal, isModalOpen } = useModal()
  const { getSessionStorageItem: hasViewedUpsell } =
    useSessionStorage('upsell-modal')
  const { cart: consumerCart, errors, cartLoading } = useConsumerCart()
  const { minimumOrderValueWarning, dynamicPrepTimeSlotValidation } =
    useCheckout()

  const handleButtonClick = async () => {
    if (cartLoading) return

    if (!consumerCart?.orderItems.length) {
      openModal('cart')
      return
    }

    const currentProductErrors = getCurrentProductErrors(errors)
    const { orderItems } = consumerCart

    if (
      currentProductErrors.length ||
      minimumOrderValueWarning ||
      dynamicPrepTimeSlotValidation
    ) {
      openModal('cart')
    } else {
      checkout(orderItems)
    }
  }

  const checkout = (orderItems: OrderItem[]) => {
    if (!consumerCart) return

    if (!isModalOpen('upsell') && !hasViewedUpsell()) {
      openModal('upsell')
      return
    }

    closeModal('cart')
    return navigate('/checkout')
  }

  return (
    <Fragment>
      <Button
        data-testid='navbar-checkout-button'
        variant='secondary'
        type='button'
        onClick={handleButtonClick}
        isLoading={cartLoading}
      >
        <DesktopContent>
          <span>Checkout</span>
          <ArrowIcon />
        </DesktopContent>
        <MobileContent>Pay Now</MobileContent>
      </Button>
    </Fragment>
  )
}

const MobileContent = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  [theme.mediaQueries.viewport7]: {
    display: 'none'
  }
}))

const DesktopContent = styled.div(({ theme }) => ({
  display: 'none',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.mediaQueries.viewport7]: {
    display: 'flex'
  }
}))

const Button = styled(GenericButton)(({ theme }) => ({
  fontSize: theme.fontSizes[0],
  height: '100%',
  color: theme.colors.textBody,
  padding: '0 8px',
  '> div > div > svg': {
    marginRight: '0'
  }
}))

export default CheckoutButton
